import TeacherDashStoreModule from "@/pages/TeacherDashboard/TeacherDashStoreModule";
import { defineStore } from "pinia";
import { ref } from "vue";

export const usePercentages = defineStore("percentages", () => {
  const percentages = ref([]);

  async function fetchPercentages() {
    try {
      const response =
        await TeacherDashStoreModule.actions.getAssessmentExams();
      percentages.value = response.data.data;
      console.log(response.data.data);
    } catch (error) {
      console.log(error);
    }
  }
  return {
    percentages,
    fetchPercentages,
  };
});
